import axios, { AxiosError, AxiosResponse } from 'axios';
import getVersionWebview from '../navigation/controlVersion';
import { TrackingEvents } from '../dataTransformation/tracking';

const { trackingApiRequest } = new TrackingEvents();
const ProblemsClient = axios.create({
    baseURL: '/be/problems/v1',
    headers: {
        'Content-type': 'application/json',
        'X-App-Info': getVersionWebview(),
    },
});

ProblemsClient.interceptors.response.use(
    (response: AxiosResponse) => {
        trackingApiRequest(response, 'SUCCESS');
        return response;
    },
    (error: AxiosError) => {
        trackingApiRequest(error, 'ERROR');
        return Promise.reject(error);
    },
);

export default ProblemsClient;
